// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2BYZI","title":"Info_title__2-CrR","selects":"Info_selects__3F3YY","requiredAsterisk":"Info_requiredAsterisk__3b6DU"};